import {
    FETCH_ABSENT_EMPLOYEE_REQUEST,
    FETCH_ABSENT_EMPLOYEE_SUCCESS,
    FETCH_ABSENT_EMPLOYEE_FAILURE,
    FETCH_ABSENT_EMPLOYEE_LOCATION_REQUEST,
    FETCH_ABSENT_EMPLOYEE_LOCATION_SUCCESS,
    FETCH_ABSENT_EMPLOYEE_LOCATION_FAILURE,
} from "../constants/AbsentEmployeeConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,

    empLoading: false,
    empData: [],
    empError: null
};

const AbsentEmployeeReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ABSENT_EMPLOYEE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_ABSENT_EMPLOYEE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_ABSENT_EMPLOYEE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case FETCH_ABSENT_EMPLOYEE_LOCATION_REQUEST:
            return {
                ...state,
                empLoading: true,
                empError: null,
            };

        case FETCH_ABSENT_EMPLOYEE_LOCATION_SUCCESS:
            return {
                ...state,
                empLoading: false,
                empData: action.payload,
                empError: null,
            };

        case FETCH_ABSENT_EMPLOYEE_LOCATION_FAILURE:
            return {
                ...state,
                empLoading: false,
                empError: action.payload,
            };

            default:
                return state;
        }
};


export default AbsentEmployeeReducer;
